<template>
    <div class="house-new-contract">
        <Breadcrumb />
        <h1>新增紙本合約</h1>
        <new-contract></new-contract>
    </div>
</template>
<script>
import Breadcrumb from '@/components/widge/Breadcrumb.vue';
import NewContract from '@/components/landlord/houseStatus/newContract/NewContract.vue';

import { mapGetters } from 'vuex'

export default {
    name: 'HouseManagement',
    data () {
        return {
            // houseFilter: false,
            listIsFixed: false,
        }
    },
    created() {
        
    },
    // mounted () {
    //     window.addEventListener('scroll', this.handleScroll);
    // },
    // destroyed() {
    //     window.removeEventListener('scroll', this.handleScroll);
    // },
    // methods: {
    //     handleScroll: function () {
    //         let scrollTop = event.target.documentElement.scrollTop
    //         console.log(scrollTop)
    //         if( scrollTop >= 50){
    //             document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'none'
    //             document.getElementsByClassName('house-management')[0].style.zIndex = '8'
    //         }else{
    //             document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
    //             document.getElementsByClassName('house-management')[0].style.zIndex = '9'
    //             this.listIsFixed = false
    //         }

    //         if( scrollTop >= 115){
    //             this.listIsFixed = true
    //         }
    //     },
    // },
    components: {
        Breadcrumb,
        NewContract
    }
}
</script>
<style lang="scss" scoped>
    .house-new-contract{
        position: relative;
        margin-top: 82px;
        > h1{
            margin-top: 26px;
            margin-bottom: 40px;
            font-size: 28px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/HouseManagementPages/HouseNewContract.vue